import type { Doodle } from '../../server/src/models'
import { findDoodleInMemory, setDoodleParentFolder } from './data/doodles'

// ドラッグ図面用

let draggingDoodle: Doodle | undefined

export const onDragDoodleStart = (e: DragEvent) => {
  if (!(e.currentTarget instanceof HTMLAnchorElement)) {
    return
  }
  const doodleId = e.currentTarget.dataset.doodleId
  const doodle = doodleId && findDoodleInMemory(doodleId)
  if (!doodle) {
    return
  }

  draggingDoodle = doodle
  e.currentTarget.classList.add('dragging')

  const img = e.currentTarget.getElementsByTagName('img')[0]
  img && e.dataTransfer?.setDragImage(img, 0, 0)
}

export const onDragDoodleEnd = (e: DragEvent) => {
  if (e.currentTarget instanceof HTMLAnchorElement) {
    draggingDoodle = undefined
    e.currentTarget.classList.remove('dragging')
  }
}

// ドロップ先フォルダー用

let dragEnterNow: HTMLAnchorElement | undefined

export const onDragEnterOnFolder: preact.DragEventHandler<HTMLAnchorElement> = e => {
  dragEnterNow = e.currentTarget
}

export const onDragLeaveOnFolder = (e: DragEvent) => {
  if (e.currentTarget !== dragEnterNow && e.currentTarget instanceof HTMLAnchorElement) {
    e.currentTarget.classList.remove('dragging-over')
  }
}

export const onDragOverOnFolder = (e: DragEvent) => {
  dragEnterNow = undefined
  if (!draggingDoodle || !(e.currentTarget instanceof HTMLAnchorElement)) {
    return
  }
  const folderId = e.currentTarget.dataset.folderId
  if (typeof folderId === 'string' && folderId !== draggingDoodle.parentFolderId) {
    e.preventDefault()
    e.stopPropagation()
    e.currentTarget.classList.add('dragging-over')
  }
}

export const onDropOnFolder = (e: DragEvent) => {
  if (!draggingDoodle || !(e.currentTarget instanceof HTMLAnchorElement)) {
    return
  }
  const folderId = e.currentTarget.dataset.folderId
  if (typeof folderId === 'string' && folderId !== draggingDoodle.parentFolderId) {
    e.preventDefault()
    e.stopPropagation()
    e.currentTarget.classList.remove('dragging-over')
    void setDoodleParentFolder(draggingDoodle.id, folderId)
  }
}
